(function () {
	'use strict';

	a3_cabin_reports.factory('LuggageComplianceFactory', LuggageComplianceFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name LuggageComplianceFactory
    * @description 
    *   Add, Update, Delete and Get Luggage Compliance per passenger-flight
    * @ngInject
    */
	function LuggageComplianceFactory(GenericService, $http, apiUrl, $timeout) {

		var objType = 'LuggageCompliance';
		var objCallback = LuggageCompliance;

        /**
         * Initialize the Passenger Incident
         * @memberof LuggageComplianceFactory
         */
		function LuggageCompliance() {
			this.GetId = GetId;
			this.isSynced = false;
		}

		var submitResponseObj = { success: false, message: '' }
		var service = {
			setAllLuggageComplianceToStorage : setAllLuggageComplianceToStorage,
			setLuggageComplianceToStorage : setLuggageComplianceToStorage,
			saveLuggageComplianceToStorage : saveLuggageComplianceToStorage,
			getLuggageComplianceFromStorage : getLuggageComplianceFromStorage,
			updateLuggageCompliance : updateLuggageCompliance,
			saveLuggageCompliance : saveLuggageCompliance,
			getLuggageComplianceByFlightId : getLuggageComplianceByFlightId,
			getPassengerLuggageCompliance : getPassengerLuggageCompliance,
			removeLuggageCompliance : removeLuggageCompliance,
			removePendingsLuggageCompliance : removePendingsLuggageCompliance,
			removeLuggageComplianceByFlightId : removeLuggageComplianceByFlightId,
			deleteAllLuggageComplianceReportsByFlightId: deleteAllLuggageComplianceReportsByFlightId,
			submitLuggageCompliance : submitLuggageCompliance,
			syncResultFormat : syncResultFormat,
			updateLuggageComplianceStorage : updateLuggageComplianceStorage,
			saveFlightIsCompliantToStorage: saveFlightIsCompliantToStorage,
			getFlightCompliantStatus:getFlightCompliantStatus,
			cleanOldData: cleanOldData
		};

		
		function GetId(){
			return this.LocalId;
		}

		/**
		 * Save All Luggage Compliance Passengers
		 * @param {array} objList 
		 */
		function setAllLuggageComplianceToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }


		/**
		 * Add or Remove a Luggage Compliance Report
		 * @param {object} luggageComplianceReport
		 */
		function setLuggageComplianceToStorage(luggageComplianceReport){
			var report = getPassengerLuggageCompliance(luggageComplianceReport.FlightId, luggageComplianceReport.UCI);

			if(report && !luggageComplianceReport.isChecked){
				removeLuggageCompliance(report.LocalId);
			}
			else if(luggageComplianceReport.isChecked){
				saveLuggageCompliance(luggageComplianceReport);
			}
		}

		/**
		 * Add a Luggage Compliance Report if it doesn't already exist, when this function is executed in loop it needs the index of report to prevent same LocalIds.
		 * @param {object} luggageComplianceReport
		 * @param {object} reportIndex
		 */
		function saveLuggageComplianceToStorage(luggageComplianceReport, reportIndex){
			if(!reportIndex){
				reportIndex = 0;
			}
			var report = getPassengerLuggageCompliance(luggageComplianceReport.FlightId, luggageComplianceReport.UCI);
			if(!report){
				//use reportIndex to prevent same LocalId value
				saveLuggageCompliance(luggageComplianceReport, reportIndex);
			}
		}
		/**
		 * Add a Luggage Compliance Report for whole flight if it doesn't already exist
		 * @param {object} luggageComplianceReport
		 */
		function saveFlightIsCompliantToStorage(luggageComplianceReport){
			var luggageComplianceReports = getLuggageComplianceByFlightId(luggageComplianceReport.FlightId);
			var report = luggageComplianceReports.find(x => x.IsFlightCompliant===true);
			if(!report){
				saveLuggageCompliance(luggageComplianceReport);
			}
		}

		/**
		 * Get all luggage compliance reports of a flight
		 * @param {number} flightId 
		 */
		function getLuggageComplianceByFlightId(flightId) {
			var allReports = getLuggageComplianceFromStorage();
			var flightReports = allReports.filter(x => x.FlightId==flightId);
			return flightReports;
		};

		function getFlightCompliantStatus(flightId) {
			var returnStatus = {IsFlightCompliant: false, Status: '', HasPendingsReports: false};
			var luggageComplianceReports = getLuggageComplianceByFlightId(flightId);
			var flightCompliantReport = luggageComplianceReports.find(x=>x.IsFlightCompliant);
			if(flightCompliantReport){
				returnStatus.IsFlightCompliant = true;
				if(flightCompliantReport.isSynced){
					returnStatus.Status = 'synced';
				}else{
					returnStatus.Status = 'pending';
				}
			}
			returnStatus.HasPendingsReports = luggageComplianceReports.some(s=>!s.IsFlightCompliant && !s.isSynced);

			return returnStatus;
		} 
	

		/**
		 * Get all luggage compliance reports
		 */
		function getLuggageComplianceFromStorage(){
			return GenericService.list(objType,objCallback);
		}

		/**
		 * Get luggage compliance report for a specific passenger in a specific flight
		 * @param {number} flightId 
		 * @param {number} uci 
		 */
		function getPassengerLuggageCompliance(flightId, uci){
			var luggageComplianceReports = getLuggageComplianceByFlightId(flightId);
			var passengerReport = luggageComplianceReports.find(x => x.UCI==uci);
			return passengerReport;
		}

		/**
		 * Update a luggage compliance report (Search by FlightId-UCI)
		 * @param {object} luggageComplianceReport 
		 */
		function updateLuggageCompliance(luggageComplianceReport){
			GenericService.save(luggageComplianceReport, objType, objCallback);
		}

		/**
		 * Create a new luggage compliance report
		 * @param {object} luggageComplianceReport 
		 */
		function saveLuggageCompliance(luggageComplianceReport, reportIndex){
			if(!reportIndex){
				reportIndex = 0;
			}
			luggageComplianceReport.LocalId = moment().valueOf() + reportIndex;
			luggageComplianceReport.isSynced = false;
            GenericService.add(luggageComplianceReport, objType, objCallback);
		}

		/**
		 * Remove customer event from storage
		 * @param {number} luggageComplianceReportId 
		 */
		function removeLuggageCompliance(luggageComplianceReportId){
			GenericService.remove(luggageComplianceReportId, objType, objCallback);
		}

		/**
		 * Remove all pendings luggage compliance reports in a flight from storage
		 * @param {number} flightId 
		 */
		function removePendingsLuggageCompliance(flightId){
			var pendingReports = getLuggageComplianceByFlightId(flightId).filter(x => !x.isSynced);
			if(pendingReports){
				pendingReports.forEach(function(unsyncedReport){
					removeLuggageCompliance(unsyncedReport.LocalId);	
				});
			}
		}

		/**
		 * Remove all luggage compliance reports in a flight from storage
		 * @param {number} flightId 
		 */
		 function removeLuggageComplianceByFlightId(flightId){
			var reports = getLuggageComplianceByFlightId(flightId);
			if(reports){
				reports.forEach(function(report){
					removeLuggageCompliance(report.LocalId);	
				});
			}
		}

		/**
		 * Delete all luggage compliance reports of this flight from db and then from local storage
		 * @param {number} flightId 
		 */
		function deleteAllLuggageComplianceReportsByFlightId(flightId){
			return $http.post(apiUrl + '/LuggageCompliance/ResetLuggageCompliance', flightId, { 'Content-Type': 'application/json' })
			.then(res => deleteReportsSuccessCallBack(res, flightId))
			.catch(res => saveReportFailedCallBack(res));
		}

		/**
        * The callback function upon successful submit
        * @param {object} res 
        * @param {object} objectToAdd 
        * @returns {object} submitResponseObj
        */
		function deleteReportsSuccessCallBack(res, flightId) {
			submitResponseObj.success = res.data.success;

            if (res.data.success) {
				removeAllLuggageCompliance(flightId);
				submitResponseObj.message = "Success";
            }
            else {
                submitResponseObj.message = res.data.errorMessage
            }
            return submitResponseObj;
		}
		
		/**
		 * Remove all luggage compliance reports of this flight from storage
		 * @param {number} flightId 
		 */
		function removeAllLuggageCompliance(flightId){
			var allReports = getLuggageComplianceByFlightId(flightId);
			if(allReports){
				allReports.forEach(function(report){
					removeLuggageCompliance(report.LocalId);	
				});
			}
		}

		/**
         * Sends flight's pending luggage compliance reports
         * @param {number} flightId The Flight identifier
         * @returns {promise} submitResponseObj
         */
        function submitLuggageCompliance(flightId) {
            var pendingReports = getLuggageComplianceByFlightId(flightId).filter(x => !x.isSynced);

			var postData = {
				"FlightId": flightId,
				"LuggageCompliance" : pendingReports
			};

            return $http.post(apiUrl + '/LuggageCompliance/Post', postData, { 'Content-Type': 'application/json' })
                .then(res => saveReportSuccessCallBack(res, pendingReports, flightId))
                .catch(res => saveReportFailedCallBack(res));
		}
		
		 /**
          * The callback function upon successful submit
          * @param {object} res 
          * @param {object} objectToAdd 
          * @returns {object} submitResponseObj
          */
		 function saveReportSuccessCallBack(res, pendingReports, flightId) {
			submitResponseObj.success = res.data.success;
            if (res.data.success) {
				updateLuggageComplianceStorage(res.data.data.LuggageComplianceReports, flightId);
				submitResponseObj.message = "Success! Your input has been sent";
				
            }
            else {
                submitResponseObj.message = res.data.errorMessage
            }
            return submitResponseObj;
        }

        /**
        * The callback function upon failure on submit
        * @returns {object} submitResponseObj
        */
        function saveReportFailedCallBack(res) {
            submitResponseObj.success = false;
            submitResponseObj.message = "Oops! Something went wrong"
            return submitResponseObj;
        }

		/**
		 * Shows sync result in dlgSync
		 * @param {object} result Sync result status
		 */
		function syncResultFormat(result) {
			var updateText;
			var upClass;

			if (result.ResponseSuccess == null) {
				updateText = "No One Piece Compliance Checks were uploaded to the server. ";
				upClass = "alert-cyan";
			} else if (result.ResponseSuccess == true) {
				updateText = "One Piece Compliance Checks were uploaded to the server. ";
				upClass = "alert-cyan";

				updateAllPendingsToSynced(result.LuggageComplianceReports);
			} else {
				updateText = "One Piece Compliance Checks failed to be uploaded to the server. ";
				upClass = "alert-deep-orange";

				cleanOldPendingChecks();
			}

			return {
				updMessage: updateText,
				updClass: upClass
			}
		}

		/**
		 * When sync succeed, update the pending luggage reports to synced
		 */
		function updateAllPendingsToSynced(syncedReports){
			var syncedReportsFromLS = getLuggageComplianceFromStorage().filter(x => x.isSynced);

			syncedReports.forEach(function(syncedReport, index){
				syncedReport.isSynced = true;
				syncedReport.LocalId =  moment().valueOf() + index;

				syncedReportsFromLS.push(syncedReport);
			});
			setAllLuggageComplianceToStorage(syncedReportsFromLS);
		}


		/**
		 * When sync fails, check for 2 day old checks and delete them
		 */
		function cleanOldPendingChecks(){
			var unsyncedReports = getLuggageComplianceFromStorage().filter(x => !x.isSynced);


			var today = new Date();
			var trimmedToday = new Date(today);
			unsyncedReports.forEach(function(unsyncedReport){
				var createdDay = new Date(unsyncedReport.Created);
				var trimmedDay = new Date(createdDay);
				var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedDay.trimTime());
				if(diffDays >= 2){
					removeLuggageCompliance(unsyncedReport.LocalId);
				}
			});
		}
		
    

		function updateLuggageComplianceStorage(LuggageComplianceReports, flightId){
			
			var allLuggageReports = getLuggageComplianceFromStorage();
			var luggageReports = allLuggageReports.filter(x => x.FlightId!=flightId);
			LuggageComplianceReports.forEach(function(syncedReport, index){
				syncedReport.isSynced = true;
				syncedReport.LocalId =  moment().valueOf() + index;

				luggageReports.push(syncedReport);
			});
			setAllLuggageComplianceToStorage(luggageReports);
			
		}

    	/**
         * Clean ls from old luggage reports
         * @param {array} flights Synced flights
         */
		function cleanOldData(responseFlightIds){
			var allLuggageReports = getLuggageComplianceFromStorage();
			
			//Filter out Philoxenia Questions of old flights
			allLuggageReports = allLuggageReports.filter(x => x != null && responseFlightIds.includes(x.FlightId));
			
			setAllLuggageComplianceToStorage(allLuggageReports);
		}


		return service;
	}
})();
